<template>
  <div class="custom-group-tours-contact pb-80 mb-mb-40 pt-80" :class="bg ? `bg-${bg}` : ''">
    <div class="container">
      <div :style="`background-image: url('${ASSETS_CDN}/images/contact/contact-background.jpg')`"
        class="
          custom-group-tours-contact-background
          flex
          items-center
          justify-center
          br-24
          overflow-hidden
          ma-0-auto
          h-300
          max-w-1024
        "
      >
        <div
          class="
            text
            py-50
            px-230
            tl-px-60
            mb-px-20
            flex flex-column
            items-center
          "
        >
          <p class="fw-700 fs-16 lh-22 ls-1 tc o-50 mb-0">
            {{ CONTACT_US_SUBHEADER }}
          </p>
          <h2 class="fs-32 mb-fs-24 fw-700 lh-38 mb-lh-28 mb-16 tc" :style=" $device.isDesktop ? 'max-width: 600px' : 'max-width: 100%'">
            {{ CONTACT_US_HEADER }}
          </h2>
          <CGTButtons
            color="yellow"
            :title="CONTACT_US_CTA"
            sendMail
            :fullWidthMobile="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CGTButtons from '~/components/pages/LandingPage/components/CGTButtons.vue'
import {
  CONTACT_US_HEADER,
  CONTACT_US_SUBHEADER,
  CONTACT_US_CTA
} from '~/constant/customGroupTours'
import { assetCDN } from '~/helper/index'

// Even-odd section background — page passes 'cream' | 'cream-deep' (default: none).
defineProps({
  bg: { type: String, default: '', validator: (v) => ['', 'cream', 'cream-deep'].includes(v) },
})

const ASSETS_CDN = assetCDN()

</script>

<style lang="scss" scoped>
.custom-group-tours-contact {
  &-background {
    //background: url('/assets/images/contact/contact-background.jpg');
    background-size: cover;
  }

  @include tablet() {
    padding: 0 25px;
  }

  @include phone() {
    padding: 0;
  }
}
</style>
